import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice d'energie potentielle gravitationnelle";
const DESCRIPTION =
  "Calculatrice d'energie potentielle gravitationnelle. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "potential energy calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/potential-energy-calculator/";
function PotentialEnergyCalculator() {
  const [mass, setMass] = useState("");
  const [gravity, setGravity] = useState("9.81");
  const [height, setHeight] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!mass || !height || !gravity) {
        setError("Veuillez entrer tous les paramètres");
        setResult(null);
        return;
      }
      const m = parseFloat(mass);
      const g = parseFloat(gravity);
      const h = parseFloat(height);
      if (m <= 0 || h < 0) {
        setError("Les valeurs doivent être positives");
        setResult(null);
        return;
      }
      const pe = m * g * h;
      setResult(pe.toFixed(2));
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice d'énergie potentielle calcule l'énergie gravitationnelle
                  stockée dans un objet. Formule: PE = m × g × h, où m est la masse, g est
                  l'accélération gravitationnelle, et h est la hauteur.
                </p>
                <ul>
                  <li>Calcul d'énergie gravitationnelle</li>
                  <li>Gravité terrestre par défaut: 9.81 m/s²</li>
                  <li>Résultats en joules</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Masse (kg)
                      </label>
                      <input
                        type="number"
                        value={mass}
                        onChange={(e) => setMass(e.target.value)}
                        placeholder="Entrez la masse"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Accélération gravitationnelle (m/s²)
                      </label>
                      <input
                        type="number"
                        value={gravity}
                        onChange={(e) => setGravity(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Hauteur (m)
                      </label>
                      <input
                        type="number"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        placeholder="Entrez la hauteur"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>
                        Énergie potentielle = <strong>{result} J</strong>
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comprendre la formule PE = mgh</h3></div>
              <div className="info-section-body">
                <p>L'energie potentielle gravitationnelle depend de trois valeurs: masse, gravite locale et hauteur. Plus un objet est lourd ou place haut, plus l'energie stockee est importante.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Quand utiliser cette calculatrice</h3></div>
              <div className="info-section-body">
                <p>Ce calcul est utile en physique scolaire, mecanique et energie pour estimer le travail necessaire pour lever un objet ou l'energie qu'il peut restituer en descendant.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils de precision</h3></div>
              <div className="info-section-body">
                <p>Gardez des unites coherentes (kg, m, m/s²). Si vous travaillez hors Terre, adaptez la gravite a la planete ou au contexte experimental pour un resultat plus realiste.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PotentialEnergyCalculator;
